module.exports = __webpack_public_path__ + "static/img/14000541.3d347e18.png";